const LANGUAGES_API = {
	LANGUAGES: '/languages'
};

export default LANGUAGES_API;
